import { render, staticRenderFns } from "./phoneDialog.vue?vue&type=template&id=6255a091"
import script from "./phoneDialog.vue?vue&type=script&lang=js"
export * from "./phoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports